<!--
    Component: TextPublication
    This is a  subcomponent of Publication Component.
    Represent a long text publication.
-->
<template>
    <div>
        <v-card-text>
            <read-more
                    :more-str="this.$t('read_more_message')"
                    :less-str="this.$t('read_less_message')"
                    :text="data.payload.text"
                    :max-chars="100"
                    link="#"  >
            </read-more>
        </v-card-text>
    </div>
</template>

<script>
    export default {
        name: "TextPublication",
        props: ['data']
    }
</script>

<style scoped>
</style>

<i18n>
    {
        "en": {
            "read_more_message": "read more",
            "read_less_message": "read less"
        },
        "es": {
            "read_more_message": "ver más",
            "read_less_message": "ver menos"
        }
    }
</i18n>